import { Point } from 'pixi.js-legacy';
import { Tooltip } from './tooltip';
export var TooltipPosition;
(function (TooltipPosition) {
    TooltipPosition[TooltipPosition["Top"] = 0] = "Top";
    TooltipPosition[TooltipPosition["Left"] = 1] = "Left";
    TooltipPosition[TooltipPosition["Right"] = 2] = "Right";
    TooltipPosition[TooltipPosition["Bottom"] = 3] = "Bottom";
})(TooltipPosition || (TooltipPosition = {}));
export class TooltipOptions {
    constructor() {
        this.text = '';
        this.position = TooltipPosition.Top;
        this.positionOffset = 20;
        this.padding = 20;
        this.tierOffset = new Point(0, 0);
        this.cornerRadius = 2;
        this.fillColour = 0xffffff;
        this.lineColour = 0x000000;
        this.textColour = 0x000000;
        this.lineThickness = 4;
    }
}
export class TooltipManager {
    constructor() {
        this.tooltips = [];
        this.allowTooltips = true;
    }
    static getInstance() {
        if (!this._instance) {
            this._instance = new TooltipManager();
        }
        return this._instance;
    }
    destroy() {
        TooltipManager._instance = undefined;
    }
    addTooltip(obj, options) {
        if (!this.allowTooltips) {
            return;
        }
        const tooltip = new Tooltip(obj, options);
        this.tooltips.push(tooltip);
        this.container.addChild(tooltip);
        return tooltip;
    }
}
